import type { PostHog } from 'posthog-js';

export function usePostHog(): PostHog | null {
  const nuxtApp = useNuxtApp();
  const posthog = (nuxtApp as any).$posthog;
  return posthog ?? null;
}
